/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Page_PrefixInputs */

const en_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page `)
};

const fr_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page `)
};

const de_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite `)
};

const it_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina`)
};

const ru_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница `)
};

const es_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

const zh_cn2_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页 `)
};

const ja_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページ`)
};

const hi_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पृष्ठ`)
};

const pt_pt2_ccsl_export_page_prefix = /** @type {(inputs: Ccsl_Export_Page_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

/**
* | output |
* | --- |
* | "Page" |
*
* @param {Ccsl_Export_Page_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_page_prefix = /** @type {((inputs?: Ccsl_Export_Page_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Page_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_page_prefix(inputs)
	if (locale === "de") return de_ccsl_export_page_prefix(inputs)
	if (locale === "it") return it_ccsl_export_page_prefix(inputs)
	if (locale === "ru") return ru_ccsl_export_page_prefix(inputs)
	if (locale === "es") return es_ccsl_export_page_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_page_prefix(inputs)
	if (locale === "ja") return ja_ccsl_export_page_prefix(inputs)
	if (locale === "hi") return hi_ccsl_export_page_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_page_prefix(inputs)
	return en_ccsl_export_page_prefix(inputs)
});